import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import AppointmentManagementTable from './AppointmentManagementTable';
import {
  Grid,
  TextField,
  Typography,
  Container,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import ListIcon from '@mui/icons-material/List';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const AppointmentManagement = (props) => { 
  
  const [viewType, setViewType] = useState('list');
  const [searchQuery, setSearchQuery] = useState('');
  const [charCount, setCharCount] = useState(0);

  const handleSearchQueryChange = (event) => {
    if (event.target.value.length > 50) {
      return;
    }

    const value = event.target.value;
    setSearchQuery(value);
    setCharCount(value.length);
  };

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setViewType(newView);
    }
  };

  return (
    <div className="App">
      <Container maxWidth={false}>
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid item>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
              Appointment Management System
            </Typography>
          </Grid>
          <Grid item>
            <ToggleButtonGroup
              value={viewType}
              exclusive
              onChange={handleViewChange}
              aria-label="view type"
            >
              <ToggleButton value="list" aria-label="list view">
                <ListIcon /> List View
              </ToggleButton>
              <ToggleButton value="calendar" aria-label="calendar view">
                <CalendarMonthIcon /> Calendar View
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </Grid>

        {/* Search Field */}

        <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Grid item>
            <Tooltip title="Search by name, phone, or agent" arrow placement="top">
              <TextField
                sx={{ width: 250 }}
                size="small"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearchQueryChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography variant="caption">{charCount}/50</Typography>
                    </InputAdornment>
                  )
                }}
              />
            </Tooltip>
          </Grid>
        </Grid>


        {viewType === 'list' ? (
          <AppointmentManagementTable 
            refreshkey={props.refreshKey} 
            searchQuery={searchQuery} 
          />
        ) : (
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Typography variant="h6">Calendar View Coming Soon</Typography>
          </div>
        )}
      </Container>
    </div>
  );
}

export default AppointmentManagement;